/* ==========================================================================
   EMPRICS Quote List System
   Stores selected products in localStorage, renders quote list page,
   handles sending quotes via Shopify contact form
   ========================================================================== */

var EmpricsQuote = (function() {
  var STORAGE_KEY = 'emprics_quote_list';

  function getItems() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch(e) { return []; }
  }

  function saveItems(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    updateBadges();
  }

  function addItem(product) {
    var items = getItems();
    var exists = items.find(function(i) { return i.handle === product.handle; });
    if (exists) {
      exists.qty = (exists.qty || 1) + 1;
    } else {
      product.qty = 1;
      product.ref = '';
      items.push(product);
    }
    saveItems(items);
    return items.length;
  }

  function removeItem(handle) {
    var items = getItems().filter(function(i) { return i.handle !== handle; });
    saveItems(items);
    return items;
  }

  function updateQty(handle, qty) {
    var items = getItems();
    var item = items.find(function(i) { return i.handle === handle; });
    if (item) {
      item.qty = Math.max(1, parseInt(qty) || 1);
      saveItems(items);
    }
    return items;
  }

  function updateRef(handle, ref) {
    var items = getItems();
    var item = items.find(function(i) { return i.handle === handle; });
    if (item) {
      item.ref = ref;
      saveItems(items);
    }
  }

  function clearAll() {
    localStorage.removeItem(STORAGE_KEY);
    updateBadges();
  }

  function getCount() {
    return getItems().length;
  }

  function updateBadges() {
    var count = getCount();
    document.querySelectorAll('.emprics-quote-badge').forEach(function(b) {
      b.textContent = count;
      b.style.display = count > 0 ? 'inline-flex' : 'none';
    });
    document.querySelectorAll('.emprics-quote-btn-wrap').forEach(function(w) {
      if (count > 0) w.classList.add('has-items');
      else w.classList.remove('has-items');
    });
  }

  /* Show toast notification */
  function showToast(msg) {
    var existing = document.getElementById('emprics-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.id = 'emprics-toast';
    toast.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0a0a0a" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg> ' + msg;
    toast.style.cssText = 'position:fixed;bottom:24px;right:24px;background:#F5D800;color:#0a0a0a;padding:14px 22px;border-radius:10px;font-size:14px;font-weight:700;z-index:99999;display:flex;align-items:center;gap:8px;box-shadow:0 8px 30px rgba(245,216,0,0.3);animation:emprics-toast-in 0.3s ease;';
    document.body.appendChild(toast);

    setTimeout(function() {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(10px)';
      toast.style.transition = 'all 0.3s ease';
      setTimeout(function() { toast.remove(); }, 300);
    }, 2200);
  }

  /* Bind "Add to Quote" buttons on collection/product pages */
  function bindAddButtons() {
    document.querySelectorAll('[data-add-to-quote]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var product = {
          handle: this.getAttribute('data-handle'),
          title: this.getAttribute('data-title'),
          sku: this.getAttribute('data-sku') || '',
          image: this.getAttribute('data-image') || '',
          type: this.getAttribute('data-type') || '',
          description: this.getAttribute('data-description') || ''
        };
        var count = addItem(product);
        showToast(product.title + ' added to quote');

        /* Animate the button */
        this.classList.add('emprics-added');
        this.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg> Added';
        var self = this;
        setTimeout(function() {
          self.classList.remove('emprics-added');
          self.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg> Add to Quote';
        }, 1800);
      });
    });
  }

  /* Render the full quote list page */
  function renderQuoteList(containerId) {
    var container = document.getElementById(containerId);
    if (!container) return;

    var items = getItems();

    if (items.length === 0) {
      container.innerHTML = '<div class="eq-empty">' +
        '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#444" stroke-width="1.5"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>' +
        '<h2>Your quote list is empty</h2>' +
        '<p>Browse our lighting range and add products to build your quote.</p>' +
        '<a href="/collections/lighting" class="emprics-btn emprics-btn--accent">Browse Lighting</a>' +
        '</div>';
      return;
    }

    var html = '<div class="eq-header-row">' +
      '<div class="eq-col eq-col--img">Image</div>' +
      '<div class="eq-col eq-col--sku">SKU</div>' +
      '<div class="eq-col eq-col--desc">Description</div>' +
      '<div class="eq-col eq-col--ref">Ref</div>' +
      '<div class="eq-col eq-col--qty">Qty</div>' +
      '<div class="eq-col eq-col--remove"></div>' +
      '</div>';

    items.forEach(function(item) {
      var imgSrc = item.image || '';
      var imgTag = imgSrc ? '<img src="' + imgSrc + '" alt="' + item.title + '" loading="lazy">' : '<div class="eq-no-img">No image</div>';

      html += '<div class="eq-row" data-handle="' + item.handle + '">' +
        '<div class="eq-col eq-col--img"><a href="/products/' + item.handle + '" class="eq-thumb">' + imgTag + '</a></div>' +
        '<div class="eq-col eq-col--sku"><span class="eq-mobile-label">SKU</span><span class="eq-sku-text">' + (item.sku || item.handle.toUpperCase()) + '</span></div>' +
        '<div class="eq-col eq-col--desc"><span class="eq-mobile-label">Description</span><a href="/products/' + item.handle + '" class="eq-title">' + item.title + '</a>' +
        (item.type ? '<span class="eq-type">' + item.type + '</span>' : '') + '</div>' +
        '<div class="eq-col eq-col--ref"><span class="eq-mobile-label">Ref</span><input type="text" class="eq-ref-input" data-handle="' + item.handle + '" value="' + (item.ref || '') + '" placeholder="Drawing ref..."></div>' +
        '<div class="eq-col eq-col--qty"><span class="eq-mobile-label">Qty</span><input type="number" class="eq-qty-input" data-handle="' + item.handle + '" value="' + (item.qty || 1) + '" min="1" max="9999"></div>' +
        '<div class="eq-col eq-col--remove"><button class="eq-remove-btn" data-handle="' + item.handle + '" title="Remove">&times;</button></div>' +
        '</div>';
    });

    html += '<div class="eq-comments-section">' +
      '<label class="eq-comments-label" for="eq-comments">Additional Comments / Notes</label>' +
      '<textarea id="eq-comments" class="eq-comments-input" rows="4" placeholder="Any special requirements, project details, delivery notes..."></textarea>' +
      '</div>';

    html += '<div class="eq-actions">' +
      '<a href="/collections/lighting" class="emprics-btn emprics-btn--outline eq-continue">Continue Browsing</a>' +
      '<button type="button" class="emprics-btn emprics-btn--ghost eq-clear-all">Clear List</button>' +
      '<button type="button" id="eq-send-quote" class="emprics-btn emprics-btn--accent eq-send">Send Quote Request</button>' +
      '</div>';

    html += '<div id="eq-send-form" style="display:none;"></div>';

    container.innerHTML = html;

    /* Bind events */
    container.querySelectorAll('.eq-qty-input').forEach(function(inp) {
      inp.addEventListener('change', function() {
        updateQty(this.getAttribute('data-handle'), this.value);
      });
    });
    container.querySelectorAll('.eq-ref-input').forEach(function(inp) {
      inp.addEventListener('input', function() {
        updateRef(this.getAttribute('data-handle'), this.value);
      });
    });
    container.querySelectorAll('.eq-remove-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var h = this.getAttribute('data-handle');
        removeItem(h);
        var row = container.querySelector('.eq-row[data-handle="' + h + '"]');
        if (row) {
          row.style.opacity = '0';
          row.style.transform = 'translateX(20px)';
          row.style.transition = 'all 0.3s ease';
          setTimeout(function() { renderQuoteList(containerId); }, 300);
        }
      });
    });
    var clearBtn = container.querySelector('.eq-clear-all');
    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        if (confirm('Clear all items from your quote list?')) {
          clearAll();
          renderQuoteList(containerId);
        }
      });
    }

    /* Send Quote */
    var sendBtn = document.getElementById('eq-send-quote');
    if (sendBtn) {
      sendBtn.addEventListener('click', function() {
        sendQuote(containerId);
      });
    }
  }

  function sendQuote(containerId) {
    var items = getItems();
    if (items.length === 0) return;

    var comments = document.getElementById('eq-comments');
    var commentsText = comments ? comments.value.trim() : '';

    /* Build the email body */
    var body = 'QUOTE REQUEST\n';
    body += '='.repeat(60) + '\n\n';

    items.forEach(function(item, idx) {
      body += (idx + 1) + '. ' + item.title + '\n';
      body += '   SKU: ' + (item.sku || item.handle.toUpperCase()) + '\n';
      body += '   Qty: ' + (item.qty || 1) + '\n';
      if (item.ref) body += '   Ref: ' + item.ref + '\n';
      if (item.type) body += '   Type: ' + item.type + '\n';
      body += '\n';
    });

    if (commentsText) {
      body += '-'.repeat(60) + '\n';
      body += 'ADDITIONAL COMMENTS:\n' + commentsText + '\n';
    }

    body += '\n' + '='.repeat(60) + '\n';
    body += 'Total items: ' + items.length + '\n';

    /* Show the send form overlay */
    var container = document.getElementById(containerId);
    var formDiv = document.getElementById('eq-send-form');
    if (!formDiv) return;

    formDiv.style.display = 'block';
    formDiv.innerHTML = '<div class="eq-send-overlay">' +
      '<h3>Send Your Quote Request</h3>' +
      '<p>Please provide your contact details and we will respond with a full quotation.</p>' +
      '<form id="eq-contact-form" class="eq-contact-form">' +
      '<div class="eq-form-row">' +
      '<div class="eq-form-field"><label>Your Name *</label><input type="text" id="eq-name" required></div>' +
      '<div class="eq-form-field"><label>Company</label><input type="text" id="eq-company"></div>' +
      '</div>' +
      '<div class="eq-form-row">' +
      '<div class="eq-form-field"><label>Email *</label><input type="email" id="eq-email" required></div>' +
      '<div class="eq-form-field"><label>Phone</label><input type="tel" id="eq-phone"></div>' +
      '</div>' +
      '<div class="eq-form-field"><label>Project Name</label><input type="text" id="eq-project"></div>' +
      '<div class="eq-form-actions">' +
      '<button type="button" class="emprics-btn emprics-btn--outline" id="eq-cancel-send">Cancel</button>' +
      '<button type="submit" class="emprics-btn emprics-btn--accent">Send Quote Request</button>' +
      '</div>' +
      '</form>' +
      '</div>';

    document.getElementById('eq-cancel-send').addEventListener('click', function() {
      formDiv.style.display = 'none';
    });

    document.getElementById('eq-contact-form').addEventListener('submit', function(e) {
      e.preventDefault();

      var name = document.getElementById('eq-name').value.trim();
      var company = document.getElementById('eq-company').value.trim();
      var email = document.getElementById('eq-email').value.trim();
      var phone = document.getElementById('eq-phone').value.trim();
      var project = document.getElementById('eq-project').value.trim();

      if (!name || !email) {
        alert('Please provide your name and email address.');
        return;
      }

      var fullBody = 'FROM: ' + name + '\n';
      if (company) fullBody += 'COMPANY: ' + company + '\n';
      fullBody += 'EMAIL: ' + email + '\n';
      if (phone) fullBody += 'PHONE: ' + phone + '\n';
      if (project) fullBody += 'PROJECT: ' + project + '\n';
      fullBody += '\n' + body;

      /* Submit via Shopify contact form endpoint */
      var formData = new FormData();
      formData.append('form_type', 'contact');
      formData.append('utf8', '\u2713');
      formData.append('contact[email]', email);
      formData.append('contact[subject]', 'Quote Request from ' + name + (company ? ' (' + company + ')' : ''));
      formData.append('contact[body]', fullBody);

      fetch('/contact#contact_form', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'text/html' }
      }).then(function(resp) {
        if (resp.ok || resp.redirected) {
          clearAll();
          container.innerHTML = '<div class="eq-success">' +
            '<svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="#F5D800" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>' +
            '<h2>Quote Request Sent</h2>' +
            '<p>Thank you, ' + name + '. Our team will review your requirements and respond with a full quotation.</p>' +
            '<a href="/collections/lighting" class="emprics-btn emprics-btn--accent">Continue Browsing</a>' +
            '</div>';
        } else {
          /* Fallback: mailto link */
          var mailBody = encodeURIComponent(fullBody);
          var mailSubject = encodeURIComponent('Quote Request from ' + name);
          window.location.href = 'mailto:quotes@emprics.com?subject=' + mailSubject + '&body=' + mailBody;
        }
      }).catch(function() {
        var mailBody = encodeURIComponent(fullBody);
        var mailSubject = encodeURIComponent('Quote Request from ' + name);
        window.location.href = 'mailto:quotes@emprics.com?subject=' + mailSubject + '&body=' + mailBody;
      });
    });

    /* Scroll to form */
    formDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /* Init */
  document.addEventListener('DOMContentLoaded', function() {
    updateBadges();
    bindAddButtons();

    /* If quote list container exists, render it */
    var qlContainer = document.getElementById('emprics-quote-list');
    if (qlContainer) {
      renderQuoteList('emprics-quote-list');
    }
  });

  /* Toast animation keyframe */
  var style = document.createElement('style');
  style.textContent = '@keyframes emprics-toast-in{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}';
  document.head.appendChild(style);

  return {
    getItems: getItems,
    addItem: addItem,
    removeItem: removeItem,
    clearAll: clearAll,
    getCount: getCount,
    updateBadges: updateBadges,
    bindAddButtons: bindAddButtons,
    renderQuoteList: renderQuoteList
  };
})();
